/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const Title = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 600,
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const Description = styled(Typography)(({theme}) => ({
  fontSize: '12px',
  fontWeight: 400,
  color: theme.palette.figma_gray_middle_dark?.main,
}));

export const Wrap = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
